var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlagBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99988,
    cy: 9.99988,
    r: 9.99988,
    fill: "#004FEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6127_68635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.93182 11.6195C6.93182 11.6195 7.35796 11.1933 8.63637 11.1933C9.91478 11.1933 10.7671 12.0456 12.0455 12.0456C13.3239 12.0456 13.75 11.6195 13.75 11.6195V6.50585C13.75 6.50585 13.3239 6.93198 12.0455 6.93198C10.7671 6.93198 9.91478 6.07971 8.63637 6.07971C7.35796 6.07971 6.93182 6.50585 6.93182 6.50585V11.6195Z",
    stroke: "white",
    strokeWidth: 1.02273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93182 14.6021V11.6191",
    stroke: "white",
    strokeWidth: 1.02273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6127_68635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.2273,
    height: 10.2273,
    fill: "white",
    transform: "translate(5.22736 5.22729)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagBlue);
export default __webpack_public_path__ + "static/media/icon_flag_blue.62345dd2f1c250f2fa88dbded2026bf1.svg";
export { ForwardRef as ReactComponent };